export const CHIRP_APP_URL = process.env.REACT_APP_CHIRP_APP_URL;
export const CHIRP_EXPERIENCE_API_URL = process.env.REACT_APP_CHIRP_EXPERIENCE_API_URL;
export const WARRAPP_NOTIFICATIONS_API_URL = process.env.REACT_APP_WARRAPP_NOTIFICATIONS_API_URL;
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
export const COGNITO_URL = process.env.REACT_APP_COGNITO_URL;
